import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import AdminConstants from 'constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

export function addAdjustment(shipment, ledger, adjustment) {
  ShipmentWebAPIUtils.addAdjustment(shipment, ledger, adjustment);
}

export async function updateVendorPayable(vendorPayableToAdjust) {
  return ShipmentWebAPIUtils.updateVendorPayable(vendorPayableToAdjust);
}

export default {
  getShipmentAuditEvents(id) {
    ShipmentWebAPIUtils.getShipmentAuditEvents(id);
  },
  createOffer(offer) {
    ShipmentWebAPIUtils.createOffer(offer);
  },

  createQuote(quote) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CREATE_QUOTE_REQUEST,
      quote,
    });
  },

  updateQuote(quote) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_QUOTE_REQUEST,
      quote,
    });
  },

  deleteQuote(quoteId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DELETE_QUOTE_REQUEST,
      quoteId,
    });
  },

  uploadBookingDocument(key, type, file) {
    ShipmentWebAPIUtils.uploadBookingDocument(key, type, file);
  },
  getDistanceV3(query) {
    ShipmentWebAPIUtils.getDistanceV3(query);
  },
  addShipmentComment(id, comment) {
    ShipmentWebAPIUtils.addComment(id, comment);
  },
  getShipments(query) {
    ShipmentWebAPIUtils.getShipments(query);
  },
  notifyCarrierAccessorials(params) {
    ShipmentWebAPIUtils.notifyCarrierAccessorials(params);
  },
  sendDeliveryOrder(jobId, emails) {
    ShipmentWebAPIUtils.sendDeliveryOrder(jobId, emails);
  },
  processBol(jobId, emails, send) {
    ShipmentWebAPIUtils.processBol(jobId, emails, send);
  },

  updateCarrier(carrier, shipments) {
    ShipmentWebAPIUtils.updateCarrier(carrier, shipments);
  },

  updateShipper(shipper, shipments) {
    ShipmentWebAPIUtils.updateShipper(shipper, shipments);
  },
  updateConsignee(consignee, shipments) {
    ShipmentWebAPIUtils.updateConsignee(consignee, shipments);
  },
  getAllShipments() {
    ShipmentWebAPIUtils.getAllShipments();
  },
  dismissError(error) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DISMISS_ERROR,
      error,
    });
  },
  updateShipmentStops(shipment, stops) {
    ShipmentWebAPIUtils.updateShipmentStops(shipment, stops);
  },
  updateShipmentStop(shipment, stop, updates) {
    ShipmentWebAPIUtils.updateShipmentStop(shipment, stop, updates);
  },
  updateShipmentStopEquipment(shipment, stop, updates, isCarrier = false) {
    ShipmentWebAPIUtils.updateShipmentStopEquipment(
      shipment,
      stop,
      updates,
      isCarrier,
    );
  },
  updateShipmentStopLoads(shipment, stop, updates) {
    ShipmentWebAPIUtils.updateShipmentStopLoads(shipment, stop, updates);
  },
  updateShipmentStopWindow(shipment, stop, changes) {
    ShipmentWebAPIUtils.updateShipmentStopScheduling(shipment, stop, changes);
  },
  updateMassShipmentStopWindow(shipments) {
    ShipmentWebAPIUtils.updateMassShipmentStopScheduling(shipments);
  },
  updateShipmentStopLocation(shipment, stop, changes) {
    ShipmentWebAPIUtils.updateShipmentStopLocation(shipment, stop, changes);
  },
  updateShipmentStopReferenceNumbers(shipment, stop, changes) {
    ShipmentWebAPIUtils.updateShipmentStopReferenceNumbers(
      shipment,
      stop,
      changes,
    );
  },
  updateStopAttempt(shipment, stop, data) {
    ShipmentWebAPIUtils.updateShipmentStopAttempt(shipment, stop, data);
  },
  closeShipment(shipment, meta) {
    ShipmentWebAPIUtils.closeShipment(shipment, meta);
  },
  cancelShipment(shipment, reason, comment) {
    ShipmentWebAPIUtils.cancelShipment(shipment, reason, comment);
  },
  cancelShipmentForUser(shipment, user, reason) {
    ShipmentWebAPIUtils.cancelShipmentForUser(shipment, user, reason);
  },
  bulkAssignDriver(driver, shipments) {
    ShipmentWebAPIUtils.bulkAssignDriver(driver, shipments);
  },
  addBulkYardStops(offsiteYardStops) {
    ShipmentWebAPIUtils.addBulkYardStops(offsiteYardStops);
  },
  assignDriver(shipment, driver) {
    ShipmentWebAPIUtils.assignDriver(shipment, driver);
  },
  getShipment(id, isAdmin) {
    ShipmentWebAPIUtils.getShipment(id, isAdmin);
  },
  getShipmentV2(id) {
    ShipmentWebAPIUtils.getShipmentV2(id);
  },
  updateTags(shipment, tags) {
    ShipmentWebAPIUtils.updateTags(shipment, tags);
  },
  updateAdminNotes(shipment, value) {
    ShipmentWebAPIUtils.updateAdminNotes(shipment, value);
  },
  updatePODStatus(shipment, value) {
    ShipmentWebAPIUtils.updatePODStatus(shipment, value);
  },

  updateAdminNotesById(id, value) {
    ShipmentWebAPIUtils.updateAdminNotesById(id, value);
  },
  updateShipperNotes(shipment, value) {
    ShipmentWebAPIUtils.updateShipperNotes(shipment, value);
  },
  updateOnHold(shipment, on_hold, on_hold_description, on_hold_reason) {
    ShipmentWebAPIUtils.updateOnHold(
      shipment,
      on_hold,
      on_hold_description,
      on_hold_reason,
    );
  },
  updateExposed(shipment, exposed) {
    ShipmentWebAPIUtils.updateExposed(shipment, exposed);
  },
  updateTrackingId(shipment, value) {
    ShipmentWebAPIUtils.updateTrackingId(shipment, value);
  },
  updateMoNumber(shipment, value) {
    ShipmentWebAPIUtils.updateMoNumber(shipment, value);
  },
  updateHAWB(shipment, value) {
    ShipmentWebAPIUtils.updateHAWB(shipment, value);
  },
  updateReferenceNumbers(shipment, referenceNumbers, updatedRefEvents) {
    ShipmentWebAPIUtils.updateReferenceNumbers(
      shipment,
      referenceNumbers,
      updatedRefEvents,
    );
  },
  updatePrice(shipment) {
    ShipmentWebAPIUtils.updatePrice(shipment);
  },
  rerateShipmentCosts(shipment, costsToBeRerated) {
    ShipmentWebAPIUtils.rerateShipmentCosts(shipment, costsToBeRerated);
  },
  uploadDocumentAndGetDocumentURI(file, job_id, stop_id, action) {
    ShipmentWebAPIUtils.uploadDocumentAndGetDocumentURI(
      file,
      job_id,
      stop_id,
      action,
    );
  },
  uploadDocument(shipment, name, file, signatory, userRole) {
    ShipmentWebAPIUtils.uploadDocument(
      shipment,
      name,
      file,
      signatory,
      userRole,
    );
  },
  uploadStopDocument(shipment, stop, docType, file, signatory) {
    ShipmentWebAPIUtils.uploadStopDocument(
      shipment,
      stop,
      docType,
      file,
      signatory,
    );
  },
  uploadShipmentDocument({ shipmentId, file, docType, signatory }) {
    ShipmentWebAPIUtils.uploadShipmentDocument({
      shipmentId,
      file,
      docType,
      signatory,
    });
  },
  deleteDocument(shipment, path) {
    ShipmentWebAPIUtils.deleteDocument(shipment, path);
  },
  deleteStopDocument(shipment, stop, path) {
    ShipmentWebAPIUtils.deleteStopDocument(shipment, stop, path);
  },
  updateShipmentType(shipment, value) {
    ShipmentWebAPIUtils.updateShipmentType(shipment, value);
  },
  updatePODValid(shipment, value) {
    const isValid = value === 'POD Valid';
    ShipmentWebAPIUtils.updatePODValid(shipment, isValid);
  },
  updateRailEvent(shipment, event, value) {
    ShipmentWebAPIUtils.updateRailEvent(shipment, event, value);
  },
  updateImportantDates(shipment, event, value) {
    ShipmentWebAPIUtils.updateImportantDates(shipment, event, value);
  },
  updateShipmentActionDates(shipment, event, value) {
    ShipmentWebAPIUtils.updateShipmentActionDates(shipment, event, value);
  },
  updateEstimatedArrival(shipment, value) {
    ShipmentWebAPIUtils.updateEstimatedArrival(shipment, value);
  },
  updateArrivalDate(shipment, value) {
    ShipmentWebAPIUtils.updateArrivalDate(shipment, value);
  },
  updateAvailableDate(shipment, value) {
    ShipmentWebAPIUtils.updateAvailableDate(shipment, value);
  },
  updateDischargeDate(shipment, value) {
    ShipmentWebAPIUtils.updateDischargeDate(shipment, value);
  },
  updateLastFreeDate(shipment, value) {
    ShipmentWebAPIUtils.updateLastFreeDate(shipment, value);
  },
  updateYardLastFreeDate(shipment, value) {
    ShipmentWebAPIUtils.updateYardLastFreeDate(shipment, value);
  },
  updateEmptyReturnedDate(shipment, value) {
    ShipmentWebAPIUtils.updateEmptyReturnedDate(shipment, value);
  },
  updateLastCutDate(shipment, value) {
    ShipmentWebAPIUtils.updateLastCutDate(shipment, value);
  },
  updateDocumentCutoffDate(shipment, value) {
    ShipmentWebAPIUtils.updateDocumentCutoffDate(shipment, value);
  },
  updateEarliestReturnDate(shipment, value) {
    ShipmentWebAPIUtils.updateEarliestReturnDate(shipment, value);
  },
  updateEarliestEmptyDate(shipment, value) {
    ShipmentWebAPIUtils.updateEarliestEmptyDate(shipment, value);
  },
  updateEmptyReadyForPickupDate(shipment, value) {
    ShipmentWebAPIUtils.updateEmptyReadyForPickupDate(shipment, value);
  },
  updatePerDiemDate(shipment, value) {
    ShipmentWebAPIUtils.updatePerDiemDate(shipment, value);
  },
  updateOutgatedDate(shipment, value) {
    ShipmentWebAPIUtils.updateOutgatedDate(shipment, value);
  },
  updateYardAvailableDate(shipment, value) {
    ShipmentWebAPIUtils.updateYardAvailableDate(shipment, value);
  },
  updateStackPosition(shipment, value) {
    ShipmentWebAPIUtils.updateStackPosition(shipment, value);
  },
  updateEquipmentType(shipment, value) {
    ShipmentWebAPIUtils.updateEquipmentType(shipment, value);
  },
  updateExceptionExemptFlag(shipment, value) {
    ShipmentWebAPIUtils.updateExceptionExemptFlag(shipment, value);
  },
  updateMGLoadId(shipment, value) {
    ShipmentWebAPIUtils.updateMGLoadId(shipment, value.trim());
  },
  clearMessage(shipmentId, index) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CLEAR_MESSAGE,
      id: shipmentId,
      index,
    });
  },
  addAccessorial(shipment, accessorial, meta) {
    ShipmentWebAPIUtils.addAccessorial(shipment, accessorial, meta);
  },
  removeAccessorial(shipment, accessorial) {
    ShipmentWebAPIUtils.removeAccessorial(shipment, accessorial);
  },
  addStopAccessorial(shipment, stop, accessorial, meta) {
    ShipmentWebAPIUtils.addStopAccessorial(shipment, stop, accessorial, meta);
  },
  removeStopAccessorial(shipment, stop, accessorial) {
    ShipmentWebAPIUtils.removeStopAccessorial(shipment, stop, accessorial);
  },
  addAdjustment(shipment, ledger, adjustment) {
    addAdjustment(shipment, ledger, adjustment);
  },
  async updateVendorPayable(vendorPayableToAdjust) {
    return updateVendorPayable(vendorPayableToAdjust);
  },
  transitionTo(shipment, node, meta) {
    ShipmentWebAPIUtils.transitionTo(shipment, node, meta);
  },
  cloneShipment(shipment, options) {
    console.log(options);
    ShipmentWebAPIUtils.cloneShipment(shipment, options);
  },
  shipmentsSearch(value) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.SHIPMENTS_SEARCH,
      value,
    });
  },
  marketsFilter(selectedMarket) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.MARKETS_FILTERED,
      selectedMarket,
    });
  },
  projectFiltered(isProject) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.PROJECT_FILTERED,
      isProject,
    });
  },
  driverMarkerClicked(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.DRIVER_MARKER_CLICKED,
      id,
    });
  },
  closeDriverJobsList(driverId) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CLOSE_DRIVER_JOBS_LIST,
      driverId,
    });
  },
  openTrackingShipment(shipment) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.OPEN_TRACKING_SHIPMENT,
      shipment,
    });
  },
  closeTrackingShipmentDetails() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CLOSE_TRACKING_SHIPMENT,
    });
  },
  shareShipment(jobId, payload) {
    ShipmentWebAPIUtils.shareShipment(jobId, payload);
  },
  createStop(jobId, payload) {
    ShipmentWebAPIUtils.createStop(jobId, payload);
  },
  addYardStop(yardStop) {
    ShipmentWebAPIUtils.addYardStop(yardStop);
  },
  cancelStop(job, stop) {
    ShipmentWebAPIUtils.cancelStop(job, stop);
  },
  copyStop(job, stop) {
    ShipmentWebAPIUtils.copyStop(job, stop);
  },
  updateStopSequences(job, updateMap) {
    ShipmentWebAPIUtils.updateStopSequences(job, updateMap);
  },
  transitionStop(job, stop, workflow, meta) {
    ShipmentWebAPIUtils.transitionStop(job, stop, workflow, meta);
  },
  completeStop(shipment, stop, file, meta) {
    ShipmentWebAPIUtils.completeStop(shipment, stop, file, meta);
  },
  completeMassStops(action, shipments) {
    ShipmentWebAPIUtils.completeMassStops(action, shipments);
  },
  arrivedMassStops(action, shipments) {
    ShipmentWebAPIUtils.arrivedMassStops(action, shipments);
  },
  updateMassShipmentStopScheduling(action, shipments) {
    ShipmentWebAPIUtils.updateMassShipmentStopScheduling(action, shipments);
  },

  clearDocuments() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CLEAR_DOCUMENTS,
    });
  },

  updateAdjustments(job, adjustments) {
    ShipmentWebAPIUtils.updateAdjustments(job, adjustments);
  },
  getShipmentsById(shipments) {
    ShipmentWebAPIUtils.getShipmentsById(shipments);
  },
  getShipmentsForBulkLFD(shipments) {
    ShipmentWebAPIUtils.getShipmentsForBulkLFD(shipments);
  },
  bulkTransitionShipmentsToArrived(body) {
    ShipmentWebAPIUtils.bulkTransitionShipmentsToArrived(body);
  },
  bulkUpdateDates(body) {
    ShipmentWebAPIUtils.bulkUpdateDates(body);
  },

  bulkUpdateNotes(body) {
    ShipmentWebAPIUtils.bulkUpdateNotes(body);
  },

  bulkUpdateShipments(body) {
    ShipmentWebAPIUtils.bulkUpdateShipments(body);
  },

  bulkUpdateCarrierCosts(updates) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.BULK_UPDATE_CARRIER_COSTS_REQUEST,
      updates,
    });
  },

  updateDeliveryOrderStatus(jobId, body) {
    ShipmentWebAPIUtils.updateDeliveryOrderStatus(jobId, body);
  },

  uploadAccessorialDocument(id, files, name, notes, message) {
    ShipmentWebAPIUtils.uploadAccessorialDocument(
      id,
      files,
      name,
      notes,
      message,
    );
  },
};
